var Stamps = require('./graphicStamps'),
    TextStamp = require('./textStamp');


module.exports = Stamps.extend({

    model: TextStamp

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/stamps/textStamps.js
 ** module id = 95
 ** module chunks = 0
 **/